<template>
  <div class="login">
    <h3 class="xy-title"><b>客户登陆</b></h3>
    <el-form ref="loginForm" :model="form" :rules="rules" label-width="80px" size="mini" @submit.native.prevent="handleSubmit">
      <el-form-item label="用户名">
        <el-input v-model="form.userid" placeholder="请输入用户名" class="k"></el-input>
      </el-form-item>
      <el-form-item label="密码" style="margin-top: 10px;">
        <el-input v-model="form.password" type="password" placeholder="请输入密码" class="k"></el-input>
      </el-form-item>
      <el-form-item style="margin-top: 10px;">
        <el-button type="primary" native-type="submit" icon="el-icon-search" style="margin-top: 10px;">登陆</el-button>
      </el-form-item>
      <el-form-item>
        <p style="line-height: 22px; overflow: hidden; font-size: 12px;">
          如果您还不是我司会员，请<a style="font-weight:bold; color:#06F;" href="http://xy56.kingtrans.cn/reg.jsp" target="_blank">立即注册</a>成为我司会员享更多优惠！</p>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {
        userid: '',
        password: '',
      },
      rules: {
        userid: [
          { required: true, message: '请输入用户名', trigger: 'blur' },
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
        ],
      },
    };
  },
  methods: {
    handleSubmit() {
      // this.$refs.loginForm.validate((valid) => {
        // if (valid) {
          const formData = new FormData();
          formData.append('userid', this.form.userid);
          formData.append('password', this.form.password)
          // 跳转到目标页面
          window.open('https://xy56.kingtrans.cn/new_index.jsp', '_blank');;
        // } else {
        //   console.log('表单验证失败');
        //   return false;
        // }
      // });
    },
  },
};
</script>

<style scoped>
.login {
  float: left;
}
.el-form-item {
  margin-bottom: 20px;
}
.el-button {
  float: right;
}
.k {
  /* width: 140px;
  height: 20px;
  line-height: 20px; */
}
</style>



// WEBPACK FOOTER //
// xy-login-form.vue?8e23ef16